import { useEffect, useState } from "react";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import { Search, MapPin, BadgePercent, Phone } from "lucide-react";

export default function RedeCredenciada() {
  const [partners, setPartners] = useState([]);
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");
  const [city, setCity] = useState("");
  const [cat, setCat] = useState("");

  const load = () => {
    const params = {};
    if (q) params.q = q;
    if (city) params.city = city;
    if (cat) params.category = cat;
    api.get("/partners", { params }).then(({ data }) => setPartners(data));
  };

  useEffect(() => {
    api.get("/partners/categories").then(({ data }) => setCats(data));
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="rede-page">
      <PublicHeader />
      <div className="pt-32 pb-16 max-w-7xl mx-auto px-6 lg:px-10">
        <span className="text-xs font-bold uppercase tracking-widest text-[#2A8FE0]">Rede Credenciada</span>
        <h1 className="mt-3 font-display text-4xl lg:text-5xl font-black text-[#0E2A5C]">Encontre o parceiro ideal</h1>
        <p className="mt-3 text-slate-600 max-w-2xl">Filtre por especialidade, cidade ou nome. Descontos imediatos para titulares Solimões Card.</p>

        <div className="mt-8 card-soft p-5 grid md:grid-cols-12 gap-3" data-testid="rede-filters">
          <div className="md:col-span-5 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Buscar por nome ou serviço" className="w-full pl-9 pr-3 py-3 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0] focus:ring-2 focus:ring-[#2A8FE0]/20" data-testid="rede-search-input" />
          </div>
          <div className="md:col-span-3">
            <input value={city} onChange={(e)=>setCity(e.target.value)} placeholder="Cidade" className="w-full px-3 py-3 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0] focus:ring-2 focus:ring-[#2A8FE0]/20" data-testid="rede-city-input" />
          </div>
          <div className="md:col-span-3">
            <select value={cat} onChange={(e)=>setCat(e.target.value)} className="w-full px-3 py-3 rounded-xl border border-slate-200 outline-none focus:border-[#2A8FE0] focus:ring-2 focus:ring-[#2A8FE0]/20" data-testid="rede-category-select">
              <option value="">Todas especialidades</option>
              {cats.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <button onClick={load} className="md:col-span-1 btn-primary text-sm" data-testid="rede-search-button">Buscar</button>
        </div>

        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {partners.map(p => (
            <div key={p.id} className="card-soft p-6" data-testid={`partner-${p.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-xs font-bold uppercase tracking-widest text-[#2A8FE0]">{p.category}</div>
                  <div className="font-display text-xl font-bold text-[#0E2A5C] mt-1">{p.name}</div>
                </div>
                <span className="inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-amber-50 text-amber-700" data-testid={`partner-discount-${p.id}`}>
                  <BadgePercent className="h-3 w-3" /> {p.discount_percent}% OFF
                </span>
              </div>
              <p className="mt-3 text-sm text-slate-600 line-clamp-2">{p.description}</p>
              <div className="mt-4 space-y-1.5 text-sm text-slate-600">
                <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-slate-400" />{p.address || `${p.city}/${p.state}`}</div>
                {p.phone && <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-slate-400" />{p.phone}</div>}
              </div>
              {p.accepts_diamante && (
                <span className="mt-4 inline-block text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full bg-sky-50 text-sky-700">Aceita Diamante</span>
              )}
            </div>
          ))}
          {partners.length === 0 && (
            <div className="md:col-span-3 text-center py-16 text-slate-500">Nenhum credenciado encontrado.</div>
          )}
        </div>
      </div>
    </div>
  );
}
